import axios from "axios"

// const ROOT_PATH = "role"
export default class UserAccessService {
	static getUserAccess = () => axios.get("./data.json")
}
